/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Container } from './style';
import { ReactComponent as WarningIcon } from '../../assets/svg/alert.svg';
import { ReactComponent as InfoIcon } from '../../assets/svg/info.svg';

const Alert = ({ info, children }) => (
  <Container info>
    {info ? (
      <InfoIcon style={{ marginRight: '0.5rem' }} />
    ) : (
      <WarningIcon style={{ marginRight: '0.5rem' }} />
    )}

    {children}
  </Container>
);

export default Alert;
